<template>
  <div class="view-tasklists">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu />
      <div id="top" class="content-wrapper">
        <div  class="container-wrapper center">
          <div class="modal-custom" v-show="showOverlay">
            <div class="loader-img-center">
              <i class="fa fa-spinner fa-spin"></i> Please wait...
            </div>
          </div>
          <div>
            <div class="">
              <h3 class="d-inline heading">Notification Manager</h3>
              <button class="d-inline btn btn-blue float-right create-btn ml-1" @click="fetchCategoryLists(), isCategoryModalVisible = true, categoryLoading = true, verrors.clear(), category_name = ''">
                Categories
              </button>
              <button class="d-inline btn btn-blue float-right create-btn" @click="createNotificationButton()">
                <i class="fa fa-plus spacer-icon" aria-hidden="true"></i>Notification
              </button>
            </div>
          </div>
          <div class="heading-seperator"></div>
          <div style="clear: both"></div>

          <div class="margin-bottom-10"></div>

          <div class="">
            <b-navbar toggleable="lg" type="light" variant="light">
              <b-navbar-brand href="#">Filter/Search</b-navbar-brand>
              <b-navbar-toggle target="nav-collapse"><i class="fa fa-chevron-down	"></i></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
                <div class="search-wrapper col-12">
                  <div class="row col-12 override-padding">
                    <div class="col-lg-4 col-12">
                      <b-form-input
                        class="input-text"
                        v-model="search_keyword"
                        type="text"
                        placeholder="Search Template Name"
                        @keyup.enter="filterNotificationManageritems()"
                        maxlength="255"
                      ></b-form-input>
                    </div>
                    <div class="col-lg-4 col-12" >
                      <b-form-input
                        class="input-text"
                        v-model="search_subject"
                        type="text"
                        placeholder="Search Subject Line"
                        @keyup.enter="filterNotificationManageritems()"
                        maxlength="255"
                      ></b-form-input>
                    </div>
                    <div class="col-lg-3 col-12 ">
                      <b-form-select
                        class="input-text"
                        v-model="search_category"
                        :options="category_options"
                        @change="filterNotificationManageritems()">
                      </b-form-select>
                    </div>
                    <div class="col-lg-1 col-12 search-icon-wrapper cursor-pointer">
                      <span @click="filterNotificationManageritems()" data-v-6167ac87="" class="search-icon"><i data-v-6167ac87="" class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div> 
              </b-collapse>
            </b-navbar>
          </div>

          <div class="margin-bottom-10"></div>
          <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin: 0;">
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              v-bind:hide-goto-end-buttons=true
              @input="showTasklistofPaginated()"
              ></b-pagination>
          </div>
          <div style="clear: both"></div>
          <div>
              <div class="row tasks_heading_row">
                <div class="bold cursor-pointer" v-on:click="sortMethod('templateName')" style="width: 28%; padding-left: 15px;">
                  Template Name
                  <i v-if="sortField == 'templateName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="sortField == 'templateName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div class="bold cursor-pointer" v-on:click="sortMethod('emailSubject')" style="width: 28%;">
                  Subject Line
                  <i v-if="sortField == 'emailSubject' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="sortField == 'emailSubject' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div class="bold cursor-pointer" v-on:click="sortMethod('smsFlag')" style="width: 12%;">
                  SMS Enabled
                  <i v-if="sortField == 'smsFlag' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="sortField == 'smsFlag' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div class="bold cursor-pointer" v-on:click="sortMethod('pushFlag')" style="width: 12%;">
                  Push Enabled
                  <i v-if="sortField == 'pushFlag' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="sortField == 'pushFlag' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div class="bold cursor-pointer" v-on:click="sortMethod('categoryName')" style="width: 14%;">
                  Category
                  <i v-if="sortField == 'categoryName' && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                  <i v-if="sortField == 'categoryName' && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div class="bold override-padding text-align-right" style="padding-right: 20px; width: 6%;">
                  &nbsp;
                </div>
              </div>
              <!-- No Notifications Text -->
              <div v-if="notification_lists.length == 0 && loading == false" style="background-color: #FFF; min-height: 480px; padding-top: 180px;" class="col-12 text-align-center">
                <div class="col-12 text-align-center no-assessment-text">No template matches your search.</div>
              </div>
              <div v-show="loading" class="loading_show">
                <div class="spinner-border text-danger"></div>
              </div>
              <div class="card-text" v-if="notification_lists.length > 0">
              <div class="tasklists-row" v-for="(list, index) in notification_lists">
                <div class="row tasklist-item" style="margin: 0;">
                  <div class="" style="width: 28%; padding-left: 15px;">
                    {{list.templateName}}
                  </div>
                  <div class="" style="width: 28%;">
                    {{list.emailSubject}}
                  </div>
                  <div class="" style="width: 12%; text-align: left; padding-left: 40px;">
                    {{getSMSPushEmableValue(list.smsFlag)}}
                  </div>
                  <div class="" style="width: 12%; text-align: left; padding-left: 40px;">
                    {{getSMSPushEmableValue(list.pushFlag)}}
                  </div>
                  <div class="" style="width: 14%;">
                    {{list.categoryName}}
                  </div>
                  <div class="override-padding" style="width: 6%;">
                    <div v-bind:id="'dropdown-container'+ index" class="dropdown" @click="toggleDropdown('actionDropdown'+index+'')" >
                      <ul class="dropbtn icons btn-right showLeft"  v-bind:id="'dotted-menu' + index" style="right: 30px;">
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                      <div v-bind:id="'actionDropdown' + index" class="dropdown-content">
                        <div class="action-dd-menu" href="" @click="editNotificationMethod(list.id)"><i class="cursor-pointer fa fa-edit spacer-icon" ></i>Edit</div>
                        <div class="action-dd-menu" href="" @click="deleteNotificationConfirm(list.id)"><i class="cursor-pointer fa fa-times spacer-icon"></i>Delete</div>

                      </div>
                    </div>
                  </div>
                </div>
                <div><hr></div>
              </div>
              <div v-if="rows > 25" class="overflow-auto float-right pagination-wrapper" style="margin-bottom: 0;">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="rows"
                  :per-page="perPage"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  v-bind:hide-goto-end-buttons=true
                  @input="showTasklistofPaginated()"
                  ></b-pagination>
              </div>
              <div style="clear: both;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <CreateCategoryModal :isModalVisible="isCategoryModalVisible" @close="isCategoryModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Notification Categories</h3></div>
      <div slot="body">
        <div class="col-12 override-padding">
          <div class="col-9 override-padding float-left">
            <input v-model="category_name"
                  name="category_name"
                  placeholder="Enter Notification Category Name..."
                  class="col-lg-12 input-text form-control"
                  style="line-height: 30px; "
                  maxlength="140" />
          </div>
          <div class="col-3 override-padding float-left">
          <button
              v-on:click="createCategory()"
              class="btn btn-blue col-12"
              style="line-height: 30px; margin-left: 15px;"
              ><b>Create</b></button>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div v-show="categoryLoading" class="loading_show">
          <div class="spinner-border text-danger"></div>
        </div>

        <div class="col-12 override-padding" v-if="categoryLoading == false">
          <div class="" style="margin: bottom: 10px;">
            <div class="bold float-left" style="width: 50%; color: #9B9B9B;">Category Name</div>
            <div class="bold float-left" style="width: 30%; color: #9B9B9B;"># of Notifications</div>
            <div class="bold float-left" style="width: 20%;">&nbsp;</div>
            <div style="clear: both;"></div>
          </div>
          <div class="" v-for="(list, index) in category_lists"  style="margin: bottom: 10px;">
            <div class="float-left" style="width: 40%; color: #9B9B9B;">{{ list.category_name }}</div>
            <div class="float-left" style="width: 40%; color: #9B9B9B; text-align: center;">{{ list.notification_count }}</div>
            <div class="float-left" v-if="list.notification_count == 0" @click="deleteCategoryConfirm(list.id)" style="width: 20%;"><i class="fa fa-times custom-remove" style="cursor: pointer;"></i></div>
            <div style="clear: both;"></div>
          </div>
          <div v-if="category_lists.length == 0" style="padding-top: 40px;">
            <div class="float-left" style="width: 90%; color: #9B9B9B;">No Notification Categories to display</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateCategoryModal>


    <CreateNotificationModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Create Notification</h3></div>
      <div slot="body">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding">
            <input v-model="notification_name"
                  name="notification_name"
                  placeholder="Enter Notification Template Name"
                  class="col-lg-12 input-text form-control"
                  style="line-height: 30px; "
                  v-validate="'required'"
                  maxlength="140" />
            <div v-if="verrors.firstByRule('notification_name', 'required')" class="margin-bottom-5 validate-warning-msg">Notification Template Name is required</div>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <div class="col-12 override-padding">
          <div class="col-9 float-left" style="padding-left: 0;">
            <b-form-select
              class="input-text"
              style="margin-right: 15px;"
              name="notification_category_id"
              v-model="notification_category_id"
              v-validate="'required'"
              :options="category_options">
            </b-form-select>
            <div v-if="verrors.firstByRule('notification_category_id', 'required')" class="margin-bottom-5 validate-warning-msg">Notification Category is required</div>
          </div>
          <div class="col-3 override-padding float-left">
          <button
              v-on:click="createNotification()"
              class="btn btn-blue col-12"
              style="line-height: 30px;"
              ><b>Create</b></button>
          </div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </CreateNotificationModal>

    <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteNotification(id)">Confirm</button>
      </div>
    </DeleteModal>

    <DeleteCategoryModal :isModalVisible="isDeleteCategoryModalVisible" :id="category_id"  @close="isDeleteCategoryModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading">Are you sure you want to delete?</div>
      <div slot="body">

      </div>
      <div slot="footer" class="col-3 override-padding">
        <button class="left col-12 btn btn-red" @click="deleteCategory(category_id)">Confirm</button>
      </div>
    </DeleteCategoryModal>


  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import CreateCategoryModal from '../admin/create-tasklist-modal.vue';
import CreateNotificationModal from '../admin/create-tasklist-modal.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import DeleteCategoryModal from '../shared/delete_modal_alert.vue';


Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
        data() {
          return {
            showOverlay: false,
            filterFlag: false,
            rows: 0,
            perPage: 25,
            currentPage: 1,
            notification_lists: [],
            category_lists: [],
            masterAdmin: false,
            admin: false,
            search_keyword: '',
            search_subject: '',
            search_category: '',
            category_options: [],
            loading: false,
            categoryLoading: false,
            sortField: '',
            sortBy: '',
            isModalVisible: false,
            isCategoryModalVisible: false,
            isDeleteModalVisible: false,
            isDeleteCategoryModalVisible: false,
            notification_name: '',
            notification_category_id: '',
            apiUrl: '',
            category_name: '',
            id: '',
            category_id: '',
          }
        },

        components: {
          UserMenu,
          GoBack,
          MasteradminSidebarMenu,
          DatePicker,
          CreateCategoryModal,
          CreateNotificationModal,
          DeleteModal,
          DeleteCategoryModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            getSMSPushEmableValue: function(val) {
              var out = 'No';
              if(val == true) {
                out = 'Yes';
              }
              return out;
            },
            truncate: function (text) {
              if (text.length > 10) {
                  return text.substring(0, 10) + '...';
              } else {
                  return text;
              }
            },
            deleteCategoryConfirm: function(category_id) {
              this.isDeleteCategoryModalVisible = true;
              this.category_id = category_id;
            },
            deleteCategory: function(category_id) {
              this.isDeleteCategoryModalVisible = false;
              this.showOverlay = true;
              axios('/notification-categories/' + category_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchCategoryOptions();
                  this.fetchCategoryLists();
               })
              .catch(error => {

              });
            },
            deleteNotificationConfirm: function(notification_id) {
              this.isDeleteModalVisible = true;
              this.id = notification_id;
            },
            deleteNotification: function(notification_id) {
              this.isDeleteModalVisible = false;
              this.showOverlay = true;
              axios('/notification-manager/' + notification_id,
                 {
                   method: 'DELETE',
                 }
               )
              .then((resp) => {
                  this.showOverlay = false;
                  this.fetchNotificationitems();
               })
              .catch(error => {

              });
            },
            createNotificationButton: function() {
              this.notification_name = '';
              this.notification_category_id = '';
              this.verrors.clear();
              this.isModalVisible = true;
            },
            editNotificationMethod: function(notification_id) {
              router.push("/edit-notification-manager/" + notification_id);
            },
            FollowDate(value) {
              return moment(String(value)).utc().format('MM/DD/YYYY')
            },
            sortMethod: function(field) {
              this.sortField = field;
              if(this.sortBy == 'ASC') {
                this.sortBy = 'DESC';
              }
              else {
                this.sortBy = 'ASC';
              }
              this.fetchNotificationitems();
            },
            showTasklistofPaginated() {
              this.fetchNotificationitems();
              this.filterFlag = false;
            },
            filterNotificationManageritems() {
              this.filterFlag = true;
              this.fetchNotificationitems();
            },
            doValidateCategoryCreate: function() {
              var vflag = 1;
              if(this.category_name == '') {
                this.categoryLoading = false;
                alert("Please enter Notification Category Name");
                vflag = 0;
                return false;
              }
              return vflag;
            },
            createCategory: function() {
              this.categoryLoading = true;
              var vflag = this.doValidateCategoryCreate();
              if(vflag == 1) {
                axios.get('/check-notification-category-name-exists/' + this.category_name, {

                })
                .then((resp) => {
                  var flag = resp.data;
                  if(flag == 1) {

                    axios('/notification-categories',
                       {
                         method: 'POST',
                         data:
                          {
                            category_name: this.category_name,
                          },
                       }
                     )
                    .then((resp) => {
                        this.category_name = '';
                        this.fetchCategoryOptions();
                        this.fetchCategoryLists();
                        //this.isCategoryModalVisible = false;
                        //this.$emit('close');
                     })
                    .catch(error => {

                    });
                  }
                  else {
                    alert("Notification Category Name already exists");
                    this.categoryLoading = false;
                    return false;
                  }
                })
                .catch(error => {

                });

              }
            },
            createNotification: function() {
              this.$validator.validateAll().then((result) => {
              if ((this.verrors.items.length === 0)) {
                  axios('/notification-manager',
                     {
                       method: 'POST',
                       data:
                        {
                          template_name: this.notification_name,
                          category_id: this.notification_category_id,
                        },
                     }
                   )
                  .then((resp) => {
                      this.notification_name = '';
                      this.notification_category_id = '';
                      this.fetchNotificationitems();
                      this.isModalVisible = false;
                      this.$emit('close');
                      router.push("/edit-notification-manager/" + resp.data);

                   })
                  .catch(error => {
                    if(error.response.data.message == 'Access denied.') {
                      router.push("/forbidden");
                    }
                  });

              }
            });
           },
            fetchCategoryOptions: function() {
              this.category_options = [];
             axios.get('/search-notification-category-options', {

             })
             .then((response) => {
                 var category_option = {value: '', text: 'Select Category'};
                 this.category_options.push(category_option);
                 for(var i=0; i < response.data.length; i++) {
                   var name = response.data[i].categoryName;
                   var category_option = {value: response.data[i].id, text: name};
                   this.category_options.push(category_option);
                 }
             })
             .catch(error => {

             });
            },
            fetchCategoryLists: function() {
              this.category_lists = [];
             axios.get('/notification-categories', {

             })
             .then((response) => {
                 this.category_lists = response.data.category;
                 this.categoryLoading = false;
             })
             .catch(error => {

             });
            },
            fetchNotificationitems() {
              this.loading = true;
              if(this.filterFlag) {
                 this.currentPage = 1;
              }
              const params = { _page: this.currentPage }
              if (this.search_keyword) {
                params.title = this.search_keyword
              }
              if (this.search_subject) {
                params.subject = this.search_subject
              }
              if (this.search_category) {
                params.category = this.search_category
              }
              if (this.sortField) {
                params.sortfield = this.sortField
              }
              if (this.sortBy) {
                params.sortby = this.sortBy
              }
              axios.get('/notification-manager', {
                 params: params
              })
              .then((resp) => {
                  this.loading = false;
                  this.notification_lists = resp.data.data;
                  this.currentPage = resp.data.page;
                  this.rows = resp.data.total_rows;
              })
              .catch(error => {

              });
            },
            toggleDropdown (id) {
              document.getElementById(id).classList.toggle("show");
            },
            hideActionMenu(e) {
              var matches = document.getElementsByClassName('dropdown-content');
              for (var i=0; i<matches.length; i++) {
                var container = document.getElementById('dropdown-container'+ i);
                if (!container.contains(e.target)) {
                     if (document.getElementById('actionDropdown' + i).classList.contains("show")) {
                        document.getElementById('actionDropdown' + i).classList.remove('show');
                     }
                }
              }
            },
          },
          mounted() {
            document.addEventListener('click', this.hideActionMenu);
          },
          beforeDestroy() {
            document.removeEventListener('click', this.hideActionMenu);
          },
         created() {
           if((store.state.page_url) && (store.state.page_url === 'Tasklists')) {
             this.selectedComponent = store.state.active_tab;
           }
           var roles = store.state.roles;
           if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
             this.masterAdmin = true;
           }
           if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
             this.admin = true;
           }
           this.fetchCategoryOptions();
           this.fetchNotificationitems();
         }
    }
</script>

<style scoped>
.dropdown {
  position: absolute;
  display: inline-block;
  right: 1.4em;
}
.edit-action-btn {
  width: 70px;
  margin-right: 5px;
}
.deactivate-btn {
  width: 83px;
  margin-right: 5px;
}
.preview-wrapper {
  padding-right: 10px;
}
.btn-dark-grey, .btn-dark-grey:hover, .btn-dark-grey:focus {
  background-color: #555;
  color: #FFF;
  border: 1px solid #555;
}
.space-wrapper {
  padding-right: 10px;
}
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}

.tasklist-item {
    padding: 12px 0px 12px 0px;
}
hr {
    border-top: 2px solid #8b8b8b;
    margin: 0px;
}
.no-assessment-text {
  font-size: 20px;
  color: #8b8b8b;
}
.mx-datepicker {
  width: 100%;
}
.custom-select {
  height: 35px;
}
.btn-blue {
  /* background-color: #dc2227 !important;
  border: 1px solid #dc2227 !important; */
  background-color: #00ACEE !important;
  border: 1px solid #00ACEE !important;
}
.create-btn {
    line-height: 15px;
    font-weight: bold;
    font-size: 13px;
    text-transform: capitalize;
}
</style>
<style>
.input-height-30 {
  line-height: 28px;
}
.assessment-title {
  text-align: center;
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: bold;
  font-size: 16px;
}
.publish-content {
  padding: 10px 40px;
  text-align: center;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/notification_manager_list.vue